export const NAVIGATION_BAR_TEST_ID = 'navigation-bar';
export const MY_PROFILE_TEST_ID = 'my-profile';
export const STATUS_SWITCH_TEST_ID = 'status-switch';
